module.exports = __webpack_public_path__ + "static/media/IRON-3USD.c375b0a2.png";